export default class Address {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  county: string;
  zipCodeExtension: string;
  addressType: number;

  constructor(
    address1: string = "",
    address2: string = "",
    city: string = "",
    state: string = "",
    zip: string = "",
    county: string = "",
    zipCodeExtension: string = ""
  ) {
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.county = county;
    this.zipCodeExtension = zipCodeExtension;
  }
}



// WEBPACK FOOTER //
// ./src/models/contact/address.ts